import { Button, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import InputField from "components/Input/InputField";
import TextArea from "components/Input/TextArea";
import WholeScreenLoader from "components/WholeScreenLoader";
import { API_URL } from "const/constants";
import useKothar from "context/useKothar";
import { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddRPLCourse = ({ importedData, color = "light", setOpenEditModal }) => {
  const [data, setData] = useState({
    courseName: null,
    collegeName: null,
    rtoCode: null,
    minCost: null,
    maxCost: null,
    sellCost: null,
    requirements: null,
  });
  const [{}, { refetchRPLCourseList }] = useKothar();
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };

  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      setData({
        ...state?.item,
      });
    }
  }, [state]);

  const { mutate, isLoading } = useMutation(postData, {
    onSuccess() {
      toast.success(data?.id ? "Course updated Successfully !!" : "Course added Successfully");

      refetchRPLCourseList();
      navigate("/admin/rpl-course");
    },
    onError() {
      toast.error(data?.id ? "Error Updating Course" : "Error Submitting Course");
    },
  });

  async function postData(payload) {
    if (data?.id) {
      await axios.put(`${API_URL}/rpl-course/${payload?.id}`, payload);
    } else {
      await axios.post(`${API_URL}/rpl-course`, payload);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const payload = {
      courseName: data?.courseName,
      key1: data?.key1,
      rtoCode: data?.rtoCode,
      minCost: Number(data?.minCost),
      maxCost: Number(data?.maxCost),
      sellCost: Number(data?.sellCost),
      requirements: data?.requirements,
      note: data?.note,
      collegeName: data?.collegeName,
      id: data?.id,
      key2: "",
      key3: "",
    };

    mutate({ ...payload });
  };

  return (
    <div className="flex flex-wrap mt-4 dashBody">
      <div className="w-full mb-12 px-4">
        <div
          className={
            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
            "bg-app-surface text-app-text"
          }
        >
          <div className="rounded-t mb-0 px-10 py-3 border-0">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex justify-start gap-4 items-center">
                <IoArrowBack className="text-xl cursor-pointer" onClick={() => navigate(-1)} />
                <h3 className={"font-semibold text-xl text-app-text"}>
                  {state ? "Edit RPL Course" : "Add RPL Course"}
                </h3>
              </div>
            </div>
          </div>

          <div className="block w-full overflow-x-auto">
            <div className="flex-auto lg:px-10 py-10 pt-0">
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                <div className="grid grid-cols-3 gap-8 mt-6 items-end">
                  <div className="relative w-full mb-3">
                    <InputField
                      label="Course Name"
                      placeholder="Enter Course Name"
                      name="courseName"
                      required
                      type="text"
                      value={data?.courseName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="College Name"
                      placeholder="Enter College Name"
                      name="collegeName"
                      type="text"
                      value={data?.collegeName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="RTO Code"
                      placeholder="Enter RTO Code"
                      name="rtoCode"
                      type="text"
                      value={data?.rtoCode}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="Minimum Cost"
                      placeholder="Enter Minimum Cost"
                      name="minCost"
                      type="text"
                      value={data?.minCost}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="Maximum Cost"
                      placeholder="Enter Maximum Cost"
                      name="maxCost"
                      type="text"
                      value={data?.maxCost}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="Selling Cost"
                      placeholder="Enter Selling Cost"
                      name="sellCost"
                      type="text"
                      value={data?.sellCost}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="mt-6">
                  <TextArea
                    label="Course Requirements"
                    placeholder="Enter Course Requirements"
                    name="requirements"
                    type="text"
                    value={data?.requirements}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mt-6">
                  <InputField
                    label="Note"
                    placeholder="Enter Note"
                    name="note"
                    type="text"
                    value={data?.note}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="w-full flex justify-end mt-6 gap-4">
                  <Button
                    variant="outlined"
                    onClick={() => (importedData ? setOpenEditModal(false) : navigate(-1))}
                  >
                    Go Back
                  </Button>
                  <Button variant="contained" type="submit">
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <WholeScreenLoader open={isLoading} />}
    </div>
  );
};

export default AddRPLCourse;
